export const TAB_QUERY_CACHE_TIME = 15 * 60 * 1000;
export const HIGHT_PRIORITY_NOTIFICATION_ARIA_LABEL = 'High Priority Notification';
export const STANDARD_PRIORITY_NOTIFICATION_ARIA_LABEL = 'Standard Priority Notification';
